import constants from "../utils/Constants";
import { getData, postData, putData } from "./rest-api-helper";


export async function addCartServ(data) {
    const details = {
        urlPath: "/prodreq/addCart",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function getCartListServ() {
    const details = {
        urlPath: `/prodreq/cart`
    }
    const res = await getData(details);
    return res.data;
}

export async function editCartServ(data) {
    const details = {
        urlPath: `/prodreq/editCart`,
        body: data
    }
    const res = await putData(details);
    return res;
}

export async function createProdReqServ(data) {
    const details = {
        urlPath: "/prodreq",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function getSingleProdReqServ(prodReqIdStrg) {
    const details = {
        urlPath: `/prodreq/single/${prodReqIdStrg}`
    }
    const res = await getData(details);
    return res.data;
}

export async function editProdReqServ(data, prodReqIdStrg) {
    const details = {
        urlPath: `/prodreq/edit/${prodReqIdStrg}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function getProdReqListServ({ limit, pageNumber, searchWord, userId, userType, deptId, projIdStrg }) {
    // if (userType === constants.approver) {
    //     const details = {
    //         urlPath: "/prodreq/byDept",
    //         queryParams: {
    //             ...(searchWord && { searchWord }),
    //             ...(limit && { limit }),
    //             ...(pageNumber && { offset: (pageNumber * limit) - limit }),
    //             ...(deptId && { deptId }),
    //         }
    //     }
    //     const res = await getData(details);
    //     return res.data;
    // } else

    if (userType === constants.focalPoint || userType === constants.lineManager) {
        const details = {
            urlPath: "/prodreq/byProj",
            queryParams: {
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                ...(projIdStrg && { projIdStrg }),
            }
        }
        const res = await getData(details);
        return res.data;
    } else if (userType === constants.requestor || userType === constants.approver) {
        const details = {
            urlPath: "/prodreq/byUserDept",
            queryParams: {
                ...(searchWord && { searchWord }),
                ...(limit && { limit }),
                ...(pageNumber && { offset: (pageNumber * limit) - limit }),
                ...(userId && { userId }),
                ...(deptId && { deptId }),
            }
        }
        const res = await getData(details);
        return res.data;
    }
}

export async function updateProdReqStatusServ(data, prodReqIdStrg) {
    const details = {
        urlPath: `/prodreq/updateStatus/${prodReqIdStrg}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}